import { Injectable } from "@angular/core";
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../app.config';
import { IInitialPageData } from '../shared/interface/general';
import get from 'lodash.get';
@Injectable({
    providedIn: 'root'
})
export class TranslationsLoader implements TranslateLoader {
    initialPageData: IInitialPageData | null = JSON.parse(get(document.getElementById('initialPageData'), 'innerHTML') || null);

    constructor(private http: HttpClient) {}
    
    getTranslation(lang: string): Observable<any> 
    {
        if (this.initialPageData && this.initialPageData.localization) {
            return of(this.initialPageData.localization);
        }

        return this.http.get(config.translateApi);
    }
    
}